module.exports = __webpack_public_path__ + "static/img/finance_bg.cd77439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/finance_bg.png
// module id = LVSp
// module chunks = 12